module.exports = __webpack_public_path__ + "img/hamburger-menu.188acce6.svg";